import './src/scss/app.scss';
import './src/scss/reset.css';